import { render } from "./DriveLocation.vue?vue&type=template&id=f6882120&scoped=true&ts=true"
import script from "./DriveLocation.vue?vue&type=script&lang=ts"
export * from "./DriveLocation.vue?vue&type=script&lang=ts"

import "./DriveLocation.vue?vue&type=style&index=0&id=f6882120&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6882120"]])

export default __exports__